const initialState = []

export const loadCountryCodeReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD_COUNTRY_CODES':
            return action.payload;
            
        case 'RESET_COUNTRY_CODES':
            return initialState;
    
        default:
            return state;
    }
};